<template>
  <Card>
    <p slot="title">
      <Icon type="md-alert" />
      统计数据管理—构建前请确认数据同步上传；
    </p>
    <template slot="extra">
      <router-link to="/inv/actual" slot="extra"
        >[SP Upload数据同步]</router-link
      >
      &nbsp; &nbsp;
      <router-link to="/inv/forecast" slot="extra"
        >[Forecast Upload数据同步]</router-link
      >
      &nbsp; &nbsp;
      <router-link to="/inv/psi" slot="extra">[进销存数据同步]</router-link>
    </template>
    <Row>
      <Col span="24">
        <Select
          v-model="query.category"
          placeholder="请选择Category"
          class="public-inp md5"
        >
          <Option
            v-for="item in categoryList"
            :value="item.category"
            :key="item.category"
            >{{ item.category }}
          </Option>
        </Select>
        <Select
          v-model="query.shortName"
          placeholder="请选择ShortName"
          class="public-inp md5"
        >
          <Option
            v-for="item in shortNameList"
            :value="item.shortName"
            :key="item.shortName"
            >{{ item.shortName }}
          </Option>
        </Select>
        <Select
          v-model="query.year"
          placeholder="请选择统计年份"
          class="public-inp md5"
        >
          <Option v-for="item in yearList" :value="item" :key="item"
            >{{ item }}
          </Option>
        </Select>
        <Select
          v-model="query.month"
          placeholder="请选择统计月份"
          class="public-inp md5"
        >
          <Option v-for="item in monthList" :value="item" :key="item"
            >{{ item }}
          </Option>
        </Select>
        <!--      <Button type="primary" icon="md-add" class="public-fr" @click="stockImport()">初始化期初|期末库存</Button>-->
        <Button
          class="public-fr"
          @click="reset()"
          v-access="'inv.inv.reset'"
          >重置</Button
        >
        <Button
          class="public-fr"
          type="primary"
          icon="ios-search"
          @click="getList()"
          v-access="'inv.inv.query'"
          >查询</Button
        >
        <Button
          class="public-fr"
          type="primary"
          icon="ios-build"
          @click="build()"
          >构建统计报表</Button
        >
      </Col>
      <Col span="24">
        <Table
          :style="{ marginTop: '10px' }"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="tbList"
        >
          <template slot-scope="{ row }" slot="action">
            <a
              href="javascript:;"
              @click="editFn(row)"
              v-access="'inv.inv.edit'"
              >编辑</a
            >
          </template>
        </Table>
        <Page
          :style="{ float: 'right', marginTop: '10px' }"
          :total="total"
          show-sizer
          show-total
          prev-text="上一页"
          next-text="下一页"
          show-elevator
          @on-change="pageNumChange"
          @on-page-size-change="pageSizeChange"
        />
      </Col>
    </Row>
  </Card>
</template>
<script>
import columns from "@/views/task/columns";

export default {
  data() {
    return {
      visiable: false,
      open: false,
      query: {
        page: 1,
        pageSize: 10,
        category: "",
        shortName: "",
        year: "",
        month: "",
      },
      columns: [
        {
          title: "id",
          key: "id",
          width: 80,
          fixed: "left",
        },
        {
          title: "年/月",
          key: "year",
          width: 85,
          render: (h, params) => {
            let name = params.row.year + "/" + params.row.month;
            return h("div", name);
          },
        },
        {
          title: "Category",
          key: "category",
          width: 100,
        },
        {
          title: "ShortName",
          key: "shortName",
          width: 125,
        },
        {
          title: "Eln",
          key: "elnInv",
          width: 80,
        },
        {
          title: "SP",
          key: "spInv",
          width: 80,
        },
        {
          title: "Retailer.*",
          key: "retailerInv",
          width: 90,
        },
        {
          title: "Rel.plan",
          key: "releasePlanInv",
          width: 90,
        },
        {
          title: "Pro.plan",
          key: "productionPlanInv",
          width: 90,
        },
        {
          title: "RetailPos",
          key: "retailPosInv",
          width: 100,
        },
        {
          title: "InTransit",
          key: "inTransitInv",
          width: 90,
        },
        {
          title: "SellIn",
          key: "sellInInv",
          width: 90,
        },
        {
          title: "SellOut",
          key: "sellOutInv",
          width: 90,
        },
        {
          title: "报表日期",
          key: "reportDate",
          width: 160,
        },
        {
          title: "创建时间",
          key: "createtime",
          width: 160,
        },
        {
          title: "更新时间",
          key: "updatetime",
          width: 160,
          fixed: "right",
        },
        {
          title: "操作",
          slot: "action",
          width: 80,
          fixed: "right",
        },
      ],
      tbList: [],
      loading: false,
      total: 0,
      yearList: [2020, 2021, 2022, 2023, 2024, 2025, 2026],
      monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      categoryList: [],
      shortNameList: [],
      isDisabled: false,
    };
  },
  created() {
    this.getList();
    this.getCategoryList();
    this.getShortNameList();
  },
  methods: {
    getCategoryList() {
      this.$api.getInvReportCategoryList({}).then((res) => {
        if (res.code == "200") {
          this.categoryList = res.data;
        }
      });
    },
    getShortNameList() {
      this.$api.getInvReportShortNameList({}).then((res) => {
        if (res.code == "200") {
          this.shortNameList = res.data;
        }
      });
    },
    getList() {
      let data = this.query;
      this.loading = true;
      this.$api.getSkuInvSummaryList(data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          this.tbList = res.data;
          this.total = res.total;
        }
      });
    },
    reset() {
      this.query.shortName = "";
      this.query.category = "";
      this.query.year = "";
      this.query.month = "";
      this.$nextTick(() => {
        this.getList();
      });
    },
    uploadToggle() {
      this.visiable = !this.visiable;
    },
    // 页码
    pageNumChange(pageNum) {
      this.query.page = pageNum;
      this.getList();
    },
    // 页数
    pageSizeChange(pageSize) {
      this.query.rows = pageSize;
      // 页码变动触发pageNumChange
      if (this.query.page == 1) {
        this.getList();
      } else {
        this.query.page = 1;
      }
    },
    editFn(row) {
      this.$router.push({
        name: "invEdit",
        query: {
          id: row.id,
        },
      });
    },
    build() {
      this.$router.push({
        name: "buildInv",
      });
    },
  },
};
</script>
<style scoped>
.md5 {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/invreport/inv.vue